import * as React from "react";
import { LoadingView } from "@lantern/react-components";
import { DocumentTitle } from "../layout";

const AuthCompletePage = () => {
  return (
    <>
      <DocumentTitle pageTitle="Authenticating" />
      <LoadingView text="Completing auth..." />
    </>
  );
};

export default AuthCompletePage;
